import React, { useEffect, useState } from "react";
import {
	View,
	Linking,
	PermissionsAndroid,
	Platform,
	ActivityIndicator,
	StyleSheet,
} from "react-native";
import { CustomContext } from "../contexts/custom-context";
import api from "../services/api";
import { account } from "../utils/account";

export const CustomProvider: React.FC = ({ children }) => {
	const [loading, setLoading] = useState(true);
	const [store, setStore] = useState("");

	useEffect(() => {
		getStore();
		loginHidden();
		setTimeout(() => setLoading(false), 2000);
	}, []);

	const getStore = async () => {
		const urlbase = (await Linking.getInitialURL()) || "";
		const url = new URL(urlbase);
		const storeId = url.searchParams.get("store") as string;
		if (!storeId) return
		setStore(storeId);
	};

	const loginHidden = () => {
		api.post("/sessions/login", account).then((response) => {
			const authToken = `Bearer ${response.data.token.token}`;
			api.defaults.headers.common["Authorization"] = authToken;
		});
	};

	const styles = StyleSheet.create({
		container: {
			flex: 1,
			justifyContent: "center",
		},
	});

	return (
		<CustomContext.Provider
			value={{
				storeId: store,
				currentLatitude: "0",
				currentLongitude: "0",
			}}
		>
			{loading ? (
				<View style={styles.container}>
					<ActivityIndicator
						size="large"
						color="#30374A"
					/>
				</View>
			) : (
				children
			)}
		</CustomContext.Provider>
	);
};
